(function () {
  const COLOR    = '#00C853';
  const BG       = '#0B0B0B';
  const DURATION = 150000; // 150s exact from source

  // ── exact radial-gradient patterns from source ─────────────────────────────
  const PATTERNS = [
    `radial-gradient(4px 100px at 0px 235px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 235px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 117.5px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 252px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 252px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 126px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 150px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 150px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 75px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 253px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 253px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 126.5px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 204px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 204px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 102px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 134px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 134px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 67px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 179px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 179px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 89.5px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 299px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 299px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 149.5px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 215px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 215px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 107.5px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 281px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 281px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 140.5px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 158px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 158px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 79px,${COLOR} 100%,transparent 150%)`,
    `radial-gradient(4px 100px at 0px 210px,${COLOR},transparent)`,
    `radial-gradient(4px 100px at 300px 210px,${COLOR},transparent)`,
    `radial-gradient(1.5px 1.5px at 150px 105px,${COLOR} 100%,transparent 150%)`,
  ].join(', ');

  const BG_SIZE = [
    '300px 235px','300px 235px','300px 235px',
    '300px 252px','300px 252px','300px 252px',
    '300px 150px','300px 150px','300px 150px',
    '300px 253px','300px 253px','300px 253px',
    '300px 204px','300px 204px','300px 204px',
    '300px 134px','300px 134px','300px 134px',
    '300px 179px','300px 179px','300px 179px',
    '300px 299px','300px 299px','300px 299px',
    '300px 215px','300px 215px','300px 215px',
    '300px 281px','300px 281px','300px 281px',
    '300px 158px','300px 158px','300px 158px',
    '300px 210px','300px 210px','300px 210px',
  ].join(', ');

  const START = [
    '0px 220px','3px 220px','151.5px 337.5px',
    '25px 24px','28px 24px','176.5px 150px',
    '50px 16px','53px 16px','201.5px 91px',
    '75px 224px','78px 224px','226.5px 230.5px',
    '100px 19px','103px 19px','251.5px 121px',
    '125px 120px','128px 120px','276.5px 187px',
    '150px 31px','153px 31px','301.5px 120.5px',
    '175px 235px','178px 235px','326.5px 384.5px',
    '200px 121px','203px 121px','351.5px 228.5px',
    '225px 224px','228px 224px','376.5px 364.5px',
    '250px 26px','253px 26px','401.5px 105px',
    '275px 75px','278px 75px','426.5px 180px',
  ];

  const END = [
    '0px 6800px','3px 6800px','151.5px 6917.5px',
    '25px 13632px','28px 13632px','176.5px 13758px',
    '50px 5416px','53px 5416px','201.5px 5491px',
    '75px 17175px','78px 17175px','226.5px 17301.5px',
    '100px 5119px','103px 5119px','251.5px 5221px',
    '125px 8428px','128px 8428px','276.5px 8495px',
    '150px 9876px','153px 9876px','301.5px 9965.5px',
    '175px 13391px','178px 13391px','326.5px 13540.5px',
    '200px 14741px','203px 14741px','351.5px 14848.5px',
    '225px 18770px','228px 18770px','376.5px 18910.5px',
    '250px 5082px','253px 5082px','401.5px 5161px',
    '275px 6375px','278px 6375px','426.5px 6480px',
  ];

  function parsePos(str) { return str.split(' ').map(parseFloat); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  const startParsed = START.map(parsePos);
  const endParsed   = END.map(parsePos);

  function init() {
    // no white flash
    document.documentElement.style.backgroundColor = BG;
    document.body.style.backgroundColor = 'transparent';

    // ── layer 1: the animated falling lines ───────────────────────────────
    const layer = document.createElement('div');
    Object.assign(layer.style, {
      position:        'fixed',
      inset:           '0',
      zIndex:          '-2',
      backgroundColor: BG,
      backgroundImage: PATTERNS,
      backgroundSize:  BG_SIZE,
      backgroundRepeat:'repeat',
      willChange:      'background-position',
    });
    document.body.appendChild(layer);

    // ── layer 2: dot grid overlay — THIS is what makes the dots visible ───
    // In the React source this is the second div with backdropFilter + backgroundImage dots
    // The key: the dot backgroundImage punches holes that reveal the lines beneath
    // blur(1em) on backdrop makes the LINES soft/blurred behind the dots — not the dots themselves
    const overlay = document.createElement('div');
    Object.assign(overlay.style, {
      position:             'fixed',
      inset:                '0',
      zIndex:               '-1',
      backdropFilter:       'blur(0.3em)',
      WebkitBackdropFilter: 'blur(0.5em)',
      // radial-gradient: transparent circle (shows blurred lines through) surrounded by BG color (dots)
      backgroundImage: `radial-gradient(circle at 50% 50%, transparent 0, transparent 1.5px, ${BG} 1.5px)`,
        backgroundSize:  '6px 6px',
      pointerEvents:        'none',
    });
    document.body.appendChild(overlay);

    // ── rAF loop ──────────────────────────────────────────────────────────
    let t0 = null;
    function tick(ts) {
      if (!t0) t0 = ts;
      const t = ((ts - t0) % DURATION) / DURATION;
      layer.style.backgroundPosition = startParsed
        .map((s, i) => {
          const e = endParsed[i];
          return `${lerp(s[0],e[0],t).toFixed(2)}px ${lerp(s[1],e[1],t).toFixed(2)}px`;
        })
        .join(', ');
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();